<mat-card class="content-card">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <mat-card-title>
      </mat-card-title>
      <div fxFlex></div>
      <a *appHasRoles="['admin', 'partner']" mat-raised-button color="primary" routerLink="add">Add order</a>
  </mat-card-header>
<app-mat-table-generator #table
    tableName = "voucherOrdersTabel"
    [columns] ="columns"
    [defaultSortField]="'id'"
    [defaultSortDirection]="'desc'"
    [dataSource] ="dataSource"
    [viewLink]="getViewLink"
    [deleteEnabled]="isAdmin()"
    [multiselectEnabled]="isAdmin()"
    [customActions]="isAdmin() && voucherOrdersCustomActions"
    >
</app-mat-table-generator>
</mat-card>
